const DEFAULT_LOCK_DURATION = 180;
const DEFAULT_NOTIFICATION_TEXT = 'Вы превысили допустимое количество попыток. Учетная запись заблокирована.';
const SETTINGS_ARRAY_START_POSITION = 0;
const SETTINGS_ARRAY_LENGTH = 100;

const UserStatus = {
  namespaced: true,

  state: {
    dateTimeTo: null,
    lockDuration: DEFAULT_LOCK_DURATION,
    notificationText: DEFAULT_NOTIFICATION_TEXT,
    paths: {
      apiSettingsPath: `settings?page=${SETTINGS_ARRAY_START_POSITION}&size=${SETTINGS_ARRAY_LENGTH}`,
      apiGeneralSuffixPath: 'sybase/',
      apiCheckStatusPath: 'check-last-reset-status/',
      apiSetStatusPath: 'status/set/',
      apiResetStatusPath: 'status/reset/'
    },
    secure: {
      authorization: {
        username: 'admin',
        password: '#fGzjd7bRLQO'
      }
    }
  },

  getters: {
    adminName() {
      return this.$store.getters['auth/adminFullname'];
    },
    usServiceBasePath() {
      return this.$store.state.usUrl;
    },
    dateTimeTo() {
      return UserStatus.state.dateTimeTo;
    },
    notificationText() {
      return UserStatus.state.notificationText != null ? UserStatus.state.notificationText : DEFAULT_NOTIFICATION_TEXT;
    }
  },

  methods: {
    getUsServiceBasePath() {
      return this.$store.state.usUrl;
    },
  },

  actions: {
    async checkUserStatusRemoteByUserLogin({ commit, dispatch, getters, rootGetters }, { userLogin }) {
      let headers = new Headers();
      headers.set('Authorization', 'Basic ' + btoa(UserStatus.state.secure.authorization.username + ":" + UserStatus.state.secure.authorization.password));
      headers.set('Content-Type', 'application/json');

      const response = await fetch(`${rootGetters.usUrl}${UserStatus.state.paths.apiGeneralSuffixPath}${UserStatus.state.paths.apiCheckStatusPath}${encodeURIComponent(userLogin)}`, {
        method: 'GET',
        headers: headers
      });

      if (!response.ok) {
        console.error(response.status);
      }

      const responseData = await response.json();
      //console.debug('responseData: ', responseData);
      if (typeof responseData !== 'undefined' && responseData != null && typeof responseData.status != 'undefined' && responseData.status != null) return responseData;
    },

    async checkStatus({ commit, dispatch, getters, rootGetters }, { userLogin }) {
      let userStatus = await dispatch('checkUserStatusRemoteByUserLogin', { userLogin: userLogin });
      let preparedDate = '',
        preparedDateString = '';

      if (typeof userStatus.createdAt != 'undefined') {
        preparedDate = new Date(userStatus.createdAt);
        preparedDate.setSeconds(preparedDate.getSeconds() + Number(UserStatus.state.lockDuration));
        preparedDateString = preparedDate.toLocaleString('RU-ru');
        UserStatus.state.dateTimeTo = preparedDateString;
      }

      //console.debug('userStatus: ', userStatus, userStatus.status, userLogin, preparedDateString);

      if (userStatus.status == 0) return 0
      else if (userStatus.status == 1) return 1
      else if (userStatus.status == 'NOT_FOUND') return 1;
    },

    async setStatusPerAccount({ commit, dispatch, getters, rootGetters }, { userLogin }) {

      let headers = new Headers();
      headers.set('Authorization', 'Basic ' + btoa(UserStatus.state.secure.authorization.username + ":" + UserStatus.state.secure.authorization.password));
      headers.set('Content-Type', 'application/json');

      const response = await fetch(`${rootGetters.usUrl}${UserStatus.state.paths.apiGeneralSuffixPath}${UserStatus.state.paths.apiSetStatusPath}${encodeURIComponent(userLogin)}`, {
        method: 'GET',
        headers: headers
      });

      if (!response.ok) {
        console.error(response.status);
        return false;
      }

      return true;
    },

    async resetStatusPerAccount({ commit, dispatch, getters, rootGetters }, { userLogin }) {
      let headers = new Headers();
      headers.set('Authorization', 'Basic ' + btoa(UserStatus.state.secure.authorization.username + ":" + UserStatus.state.secure.authorization.password));
      headers.set('Content-Type', 'application/json');

      const response = await fetch(`${rootGetters.usUrl}${UserStatus.state.paths.apiGeneralSuffixPath}${UserStatus.state.paths.apiResetStatusPath}${encodeURIComponent(userLogin)}`, {
        method: 'GET',
        headers: headers
      });

      if (!response.ok) {
        console.error(response.status);
        return false;
      }

      let settingsObject = response.json();

      return settingsObject.content;
    },

    async requestUserStatusSettings({ commit, dispatch, getters, rootGetters }, { }) {
      let headers = new Headers();
      headers.set('Authorization', 'Basic ' + btoa(UserStatus.state.secure.authorization.username + ":" + UserStatus.state.secure.authorization.password));
      headers.set('Content-Type', 'application/json');

      const response = await fetch(`${rootGetters.usUrl}${UserStatus.state.paths.apiGeneralSuffixPath}${UserStatus.state.paths.apiSettingsPath}`, {
        method: 'GET',
        headers: headers
      });

      if (!response.ok) {
        console.error(response.status);
        return false;
      }

      return response.json();
    },

    async saveSettingsToStorage({ commit, dispatch, getters, rootGetters }) {
      let settingsGetter = async () => {
        let headers = new Headers();
        headers.set('Authorization', 'Basic ' + btoa(UserStatus.state.secure.authorization.username + ":" + UserStatus.state.secure.authorization.password));
        headers.set('Content-Type', 'application/json');

        const response = await fetch(`${rootGetters.usUrl}${UserStatus.state.paths.apiSettingsPath}`, {
          method: 'GET',
          headers: headers
        });

        if (!response.ok) {
          console.error(response.status);
          return false;
        }

        return response.json();
      };

      const settings = await settingsGetter();

      console.debug(settings);

      if (typeof settings != 'undefined' && settings && typeof settings.content != 'undefined' && settings.content) {
        Array.from(settings.content).forEach((item) => {
          if (item && item.value && item.ukey) {
            localStorage.setItem(item.ukey, item.value.replace(/(<([^>]+)>)/gi, ''));
          }
        })
      }
    },

    async updateDefaultNotificationTextFromSettings() {
      let setting = localStorage.getItem('POH_ADMIN_BANNED_TEXT');

      if (typeof setting != 'undefined' && setting) {
        try {
          UserStatus.state.notificationText = setting;
        } catch (error) {
          throw error;
        }
      }
    },

    async updateDefaultTimerFromSettings() {
      let setting = localStorage.getItem('DO_ACTIVE_STATUS_SYBASE_AFTER_SECONDS');

      if (typeof setting != 'undefined' && setting) {
        try {
          UserStatus.state.lockDuration = setting;
        } catch (error) {
          throw error;
        }
      }
    }
  }
};

export default UserStatus;


// WEBPACK FOOTER //
// ./src/store/modules/userStatus.js